import {GET_SSHKEYS,ADD_SSHKEY,DELETE_SSHKEY,SSHKEY_ERROR,CLEAR_ERRORS,SELECT_KEY,CANCEL_KEY} from './sshkeyTypes';
import axios from 'axios';

export const getSshkeys = () => async (dispatch) => {
  try {
    const res = await axios.get('/api/keys');
    dispatch({type: GET_SSHKEYS, payload: res.data});
  } catch (err) {
    dispatch({type: SSHKEY_ERROR, payload: err.response.data.msg});
  }
};

export const addSshkey = (key) => async (dispatch) => {
  const config = {
    headers: {'content-Type': 'application/json'}
  };
  try {
    const res = await axios.post('/api/keys', key, config);
    if(res.data){
      dispatch({type: ADD_SSHKEY, payload: key.sshkey});
    }else{
      dispatch({type: SSHKEY_ERROR, payload: 'add sshkey failed'});
    }
  } catch (err) {
    dispatch({type: SSHKEY_ERROR, payload: err.response.data.msg});
  }
};

export const deleteSshkey = (key) => async (dispatch) => {
  try {
    const res = await axios.delete('/api/keys', {params: key});
    if(res.data){
      dispatch({type: DELETE_SSHKEY, payload: key.sshkey});
    }else{
      dispatch({type: SSHKEY_ERROR, payload: 'delete sshkey failed'});
    }
  } catch (err) {
    dispatch({type: SSHKEY_ERROR, payload: err.response.data.msg});
  }
};

export const clearSshErr = () => ({type: CLEAR_ERRORS});

export const selectSshkey = key => ({type:SELECT_KEY, payload:key.sshkey});

export const cancelSshkey = key => ({type:CANCEL_KEY});

